import { mapGetters, mapActions } from 'vuex'
import journal from '@/api/journal'
import { editorManuscript, editor } from '@/api/editor'
import { settingJournalAtype } from '@/api/setting'
import { editorAssign } from '@/api/editor'
import special from '@/api/special'
import section from '@/api/section'
import { settingCountry } from '@/api/setting'
import userApi from '@/api/user'
import manuscript from '@/api/manuscript'
import SiteSearchGroup from '@/components/search-group'
import { ARTICLE_STATUS, REVIEWER_STATUS } from '@/utils/dict'
import help from '@/utils/help'

import AssignEditorDialog from './dialog/assign-editor.dialog'
import EditDate from './dialog/edit-date.dialog'
import ReviewResult from './dialog/review-result.dialog'
import RejectReason from './dialog/reject-reason.dialog'
import SendEmail from './dialog/send-email.dialog'
import CreatePDF from './dialog/createPDF.dialog'
import { getUploadConfig } from '@/utils/upload'
import vm from '../../../main'

const columns = [
  {
    title: '',
    enTitle: 'Article Title',
    width: 220,
    dataIndex: 'code',
    slot: 'title',
    sort: true
  },
  {
    title: '',
    enTitle: 'Special Issue',
    width: 230,
    dataIndex: 'special',
    slot: 'special',
    sort: true
  },
  {
    title: '',
    enTitle: 'Assigned Editor',
    width: 120,
    dataIndex: 'editor',
    slot: 'editor',
    sort: true
  },
  {
    title: '',
    enTitle: 'Submission Date',
    width: 150,
    dataIndex: 'firstSubmitTime',
    slot: 'date',
    sort: true
  },
  {
    title: '',
    enTitle: 'Current Status',
    width: 220,
    dataIndex: 'status',
    slot: 'status',
    sort: true
  },
  {
    title: '',
    enTitle: 'Last Action Date',
    width: 150,
    dataIndex: 'lastOperateTime',
    slot: 'date',
    sort: true
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 190,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    SiteSearchGroup,
    AssignEditorDialog,
    EditDate,
    ReviewResult,
    RejectReason,
    SendEmail,
    CreatePDF
  },
  data() {
    return {
      columns,
      ARTICLE_STATUS,
      articleStatus: ARTICLE_STATUS,
      REVIEWER_STATUS,
      reviewerStatus: REVIEWER_STATUS,
      STATUS: {
        newSubmissions: 'New Submissions',
        underProcessing: 'Under Processing',
        accepted: 'Accepted',
        rejectOrWithdrawn: 'Rejected or Withdrawn',
        online: 'Online'
      },
      emptyText: {
        newSubmissions: 'There is no recent submission.',
        underProcessing: 'There is no manuscript which is under processing .',
        accepted: 'There is no manuscript which has been accepted.',
        rejectOrWithdrawn:
          'There is no manuscript which has been rejected or withdrawn. ',
        online: 'There is no manuscript which is online .',
        all: 'There is no manuscript.'
      },

      showAssignEditor: false,
      showEditDate: false,
      showReviewResult: false,
      showRejectReason: false,
      showSendEmail: false,

      inputData: {},
      event: '',
      date: [],

      showAdv: false,
      journalList: [],
      editorList: [],
      typeList: [],
      specialList: [],
      sectionList: [],
      dataSource: [],
      params: {
        searchStatus: 'underProcessing',
        journalId: '',
        assigned: true,
        nameOrEmail: '',
        codeOrDoi: '',
        status: '',
        editorId: '',
        countryCode: '',
        typeCode: '',
        submittedDate: '',
        sectionId: '',
        specialId: '',
        type: false,
        sorted: '-statusTime'
      },
      countryList: [],
      countObj: {
        ALL: 0,
        newSubmissions: 0,
        underProcessing: 0,
        accepted: 0,
        rejectOrWithdrawn: 0
      },
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      emailType: '',
      emailData: '',
      pdfType: 'Invoice',
      isVisablePDF: false,
      onlyVersion: '',
      timeList: {
        Today: 'Today',
        Yesterday: 'Yesterday',
        day7: 'Last 7 days',
        day30: 'Last 30 days'
      },
      isActive: '',
      disable: false,
      disableAE: false,
      mailFiles: [],
      isChecked: false // show country radio
    }
  },

  beforeRouteEnter(to, from, next) {
    if (from.name === '/home') {
      next(vm => {
        vm.handleClear()
        vm.showAdv = true
        vm.params.status = vm.$route.query.status

        switch (vm.params.status) {
          case 'SUBMITTED':
            vm.params.searchStatus = 'newSubmissions'
            vm.getList()
            break
          case 'REJECTED':
          case 'WITHDRAWN':
            vm.params.searchStatus = 'rejectOrWithdrawn'
            vm.getList()
            break
          case 'ONLINE':
            vm.params.searchStatus = 'online'
            vm.getList()
            break
          case 'PAPER_ACCEPTED':
            vm.params.searchStatus = 'accepted'
            vm.getList()
            break
          default:
            vm.params.searchStatus = 'underProcessing'
            vm.getList()
            break
        }

        // // vm.params.searchStatus =
        // vm.params.vm.getList()
      })
    } else {
      next()
    }
  },

  computed: {
    ...mapGetters({
      language: 'getLanguage',
      user: 'getUser',
      publisherId: 'getPublisherId'
    })
  },
  // watch: {
  //   params: {
  //     async handler(val) {
  //       if (val.status) {
  //         await this.getList()
  //       }
  //     },
  //     immediate: true
  //   }
  // },

  async activated() {
    if (this.$route.meta.keepAlive) {
      this.countrySearch()
      const { query } = this.$route
      if (Object.keys(query).length) {
        this.params = Object.assign(this.params, query)
        this.showAdv = true
      }
      await this.getOnlyList()
      // this.params.assigned = localStorage.getItem('assigned') === '1'
      await this.getJournalList()
      // this.getSpecial()
      // 详情返回列表刷新
      await this.getList()
      help.closeAutocomplete()
    }
  },
  async mounted() {
    this.countrySearch()
    const { query } = this.$route
    if (Object.keys(query).length) {
      this.params = Object.assign(this.params, query)
      this.showAdv = true
    }
    await this.getOnlyList()
    // this.params.assigned = localStorage.getItem('assigned') === '1'
    await this.getJournalList()
    // this.getSpecial()
    // 详情返回列表刷新
    await this.getList()
    help.closeAutocomplete()
  },
  methods: {
    ...mapActions(['updateLoading']),
    async getList(page = 1) {
      // if (!this.params.journalId) {
      //   return
      // }
      if (this.params.firstSubmitStartTime && !this.params.firstSubmitEndTime) {
        this.params.firstSubmitEndTime = this.$moment()
      }
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })

      this.updateLoading(true)
      const { list, pageIndex, pageSize, total } = await editorManuscript.get(
        data
      )
      this.dataSource = list

      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
      this.getCount()

      this.updateLoading(false)
    },

    async getOnlyList() {
      // const res = await editor.manuscriptOnly({ personId: this.user.id })
      // await user.editSetting('ONLY_MANUSCRIPT', value)
      const res = await userApi.setting('ONLY_MANUSCRIPT')
      this.params.assigned = res && res.value === '1' ? true : false
      this.disableAE = this.params.assigned ? true : false
      this.params.editorId = this.params.assigned ? '' : this.params.editorId
      // this.params.assigned = res.onlyManuscript
      this.onlyVersion = res && res.version
    },

    async handleDateChange(date) {
      this.params.firstSubmitStartTime = date[0] ? date[0].startOf('d') : ''
      this.params.firstSubmitEndTime = date[1] ? date[1].endOf('d') : ''
      this.getList()
    },

    async getCount() {
      const { searchStatus, ...data } = this.params
      data.type = false
      const res = await editorManuscript.status(data)

      let all = 0
      for (let key in res) {
        all += res[key]
      }
      res.all = all

      this.countObj = res
    },
    async getType(keyword) {
      if (!this.params.journalId) {
        this.disable = true
        this.disableAE = true
        return
      }
      this.disable = false
      this.disableAE = this.params.assigned ? true : false
      this.typeList = await settingJournalAtype.getAll({
        journalId: this.params.journalId,
        keyword
      })
    },
    async getSection(journalId) {
      if (!this.params.journalId) {
        this.disable = true
        this.disableAE = true
        return
      }
      this.disable = false
      this.disableAE = this.params.assigned ? true : false
      this.sectionList = await section.getAll({ journalId })
    },
    async getJournalList() {
      this.journalList = await journal.userGet({ released: true })
      this.journalList.unshift({
        name: 'All',
        journalId: '',
        id: ''
      })
      const flag = this.journalList.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }
      // if (!this.params.journalId) {
      //   return
      // }
      this.changeJournal(this.params.journalId)
      // this.getList()
    },
    async getEditors(search) {
      if (!this.params.journalId) {
        this.disable = true
        this.disableAE = true
        return
      }
      this.disable = false
      this.disableAE = this.params.assigned ? true : false
      this.editorList = await editorAssign.get({
        journalId: this.params.journalId,
        search
      })
    },
    searchList(key) {
      this.isActive = key
      if (key === 'Yesterday') {
        this.params.firstSubmitStartTime = this.$moment().subtract(1, 'days')
        this.params.firstSubmitEndTime = this.$moment()
      } else if (key === 'Today') {
        this.params.firstSubmitStartTime = this.$moment()
        this.params.firstSubmitEndTime = this.$moment()
      } else if (key === 'day7') {
        this.params.firstSubmitStartTime = this.$moment().subtract(7, 'days')
        this.params.firstSubmitEndTime = this.$moment()
      } else if (key === 'day30') {
        this.params.firstSubmitStartTime = this.$moment().subtract(30, 'days')
        this.params.firstSubmitEndTime = this.$moment()
      } else {
        this.params.firstSubmitStartTime = null
        this.params.firstSubmitEndTime = null
      }
      this.getList()
    },
    handleClear() {
      this.params.nameOrEmail = ''
      this.params.codeOrDoi = ''
      this.params.status = ''
      this.params.editorId = ''
      this.params.countryCode = ''
      this.params.typeCode = ''
      this.params.submittedDate = ''
      this.params.sectionId = ''
      this.params.specialId = ''
      this.params.firstSubmitStartTime = null
      this.params.firstSubmitEndTime = null
      this.isActive = ''
      this.date = []
      this.getList()
    },
    changeJournal(val) {
      this.getType()
      this.getSection(val)
      this.getEditors()
      this.getList()
      this.getSpecial()
      localStorage.setItem('journalId', val)
    },

    async countrySearch(val) {
      this.countryList = await settingCountry.getAll({
        keyword: val
      })
    },

    async getSpecial(val) {
      if (!this.params.journalId) {
        this.disable = true
        this.disableAE = true
        return
      }
      this.disable = false
      this.disableAE = this.params.assigned ? true : false
      this.specialList = await special.getByTitle({
        journalId: this.params.journalId,
        released: true,
        limit: 20,
        title: val
      })
    },

    copyCode(val) {
      help.copyToBlock(val)
      this.$message.success({
        title: 'Success',
        content: 'The Manuscript No. has been copied to the clipboard!'
      })
    },

    changeStatus(val) {
      this.params.searchStatus = val
      this.getList()
    },

    changeEditor(val) {
      this.inputData = val
      this.showAssignEditor = true
    },
    async exp() {
      const res = await editorManuscript.export(this.params)
      help.download(res.url, res.fileName)
    },
    detail(record) {
      // help.openWindow('/editorial-office/manuscripts/details/' + record.id)
      // window.open('/editorial-office/manuscripts/details/' + record.id)
      this.$router.push(`/editorial-office/manuscripts/details/${record.id}`)
    },
    inviteReviewer(record) {
      this.$router.push(
        `/editorial-office/manuscripts/details/${record.id}#ReviewHistory`
      )
    },
    submitDecision(record) {
      this.$router.push(
        `/editorial-office/manuscripts/decisions-editorial?sign=${record.sign}&manuscriptId=${record.id}`
      )
    },
    openReviewer(key, val) {
      switch (key) {
        case 'COMPLETED':
          help.openWindow(
            `/editorial-office/manuscripts/details/reviews-report/${val.id}`
          )
          break
        case 'DECLINED':
          this.showRejectReason = true
          this.inputData = val
          break
        default:
          this.showReviewResult = true
          this.inputData = val
          break
      }
    },
    openReviewerOther(key, val) {
      switch (key) {
        case 'COMPLETED':
          break
        case 'DECLINED':
          this.showRejectReason = true
          this.inputData = val
          break
        default:
          this.showReviewResult = true
          this.inputData = val
          break
      }
    },
    editDate(val) {
      this.showEditDate = true
      this.inputData = val
    },
    async backToAuthor(record) {
      // const { id, version, sign } = record
      // await editor.dismiss(id, {
      //   version,
      //   sign
      // })
      // this.$message.success({
      //   title: 'Success',
      //   content: `This Manuscript has been backed to author!`
      // })

      this.sendEmail(record, 'BACK_TO_AUTHOR', 'back_to_author')
    },
    finalDecision(record) {
      this.$router.push(
        '/editorial-office/manuscripts/decisions-final?sign=' +
          record.sign +
          '&manuscriptId=' +
          record.id
      )
    },
    reviewResult(record) {
      this.$router.push(
        '/editorial-office/manuscripts/details/review-result/' + record.id
      )
    },
    async withdraw(record) {
      // this.sendEmail(record, 'WITHDRAW')
      const { id, version, sign } = record
      await editor.withdraw(id, {
        version,
        sign
      })
      this.$message.success({
        title: 'Success',
        content: `This Manuscript has been withdraw!`
      })
      this.getList()
    },
    corespondenceRecord(record) {
      this.$router.push(
        '/editorial-office/manuscripts/corespondence-record/' + record.id
      )
    },

    confirm() {
      this.showEditDate = false
      this.showAssignEditor = false
      this.getList()
    },
    cancel() {
      this.showEditDate = false
      this.showAssignEditor = false
      this.showReviewResult = false
      this.showRejectReason = false
      this.showSendEmail = false
      this.isVisablePDF = false
    },
    // 发送邮件
    async sendEmail(val, event, type) {
      this.emailType = type
      this.emailData = val
      this.mailFiles = []
      this.getList()
      this.inputData = {
        manuscriptId: val.id,
        sign: val.sign,
        journalId: val.journalId,
        editorId: val.editor && val.editor.id,
        authorPersonId: val.submitter && val.submitter.id,
        email: val.submitter && val.submitter.email
      }
      if (this.emailType === 'invoice_to_author') {
        const url = await getUploadConfig(
          this.emailData.__file,
          `${this.publisherId}/journal/${
            this.inputData.journalId
          }/invoice/${help.guid()}`
        )
        this.mailFiles.push({
          name: this.emailData.__file.name + '.pdf',
          size: this.emailData.__file.size,
          path: url
        })
        this.isVisablePDF = false
      }
      this.event = event
      this.showSendEmail = true
    },
    async send() {
      if (this.emailType === 'widthdraw') {
        this.withdraw(this.emailData)
      }
      if (this.emailType === 'back_to_author') {
        const { id, version, sign } = this.emailData
        await editor.dismiss(id, {
          version,
          sign
        })
        this.$message.success({
          title: 'Success',
          content: `This Manuscript has been backed to author!`
        })
        this.getList()
      }
      if (
        this.emailType === 'remind_author_revise' ||
        this.emailType === 'manuscript_online'
      ) {
        await editor.reviseRemind(this.emailData.id, {
          sign: this.emailData.sign
        })
        this.getList()
      }
      this.cancel()
    },
    async changeAssigned() {
      this.params.assigned = !this.params.assigned
      const data = {
        value: this.params.assigned ? '1' : '0',
        version: this.onlyVersion
      }
      // await user.manuscriptEditOnly(data)
      await userApi.editSetting('ONLY_MANUSCRIPT', data)
      await this.getOnlyList()
      await this.getList()
      // localStorage.setItem('assigned', this.params.assigned ? '1' : '0')
    },

    // 控制 show country 列显示与隐藏
    showCountry() {
      this.isChecked = !this.isChecked
      if (this.isChecked) {
        this.columns.splice(1, 0, {
          title: '',
          enTitle: 'Country',
          width: 120,
          dataIndex: 'countryNameList',
          slot: 'country',
          sort: true
        })
      } else {
        this.columns = this.columns.filter(
          col => col.dataIndex !== 'countryNameList'
        )
      }
    },
    createCanvans(val, type) {
      if (!val.invoiced) {
        this.inputData = val
        this.pdfType = type
        this.isVisablePDF = true
      } else {
        this.$message.error({
          title: 'Error',
          content:
            'Please contact our billing colleague at (invoice@imrpress.com) to creat the invoice manually for this manuscript. '
        })
      }
    },
    onOrderChanage(val) {
      this.params.sorted = val
      // if (val === 'firstSubmitTime' || val === '-firstSubmitTime') {
      //   this.params.type = true
      // } else {
      //   this.params.type = false
      // }
      this.getList()
    },
    async remindAuthor(val) {
      this.sendEmail(val, 'REMIND_AUTHOR_REVISE', 'remind_author_revise')
    },
    statusFilter(val) {
      this.articleStatus = {}
      const obj = {}
      for (let k in ARTICLE_STATUS) {
        if (
          ARTICLE_STATUS[k].toUpperCase().includes(val.toUpperCase()) ||
          ARTICLE_STATUS[k].toLowerCase().includes(val.toLowerCase())
        ) {
          obj[k] = ARTICLE_STATUS[k]
        }
      }
      this.articleStatus = obj
    },
    async lock(record) {
      let content = ``
      if (record.locked === true) {
        content = `Now Academic Editor can see this manuscript details!`
      } else {
        content = `Now Academic Editor can not see this manuscript details!`
      }
      await manuscript.locked(record.id, !record.locked)
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    }
  }
}
